import React, { useState } from "react";

const html = `
<p class=MsoNormal align=center style='margin-bottom:0cm;text-align:center;
line-height:normal;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#666666'>개인<span
lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 처리방침</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>㈜소네트<span
lang=EN-US>(</span>이하<span lang=EN-US> “</span>회사<span lang=EN-US>”)</span>는 고객의
개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보를 중요시하며 「정보통신망 이용촉진 및 정보보호
등에 관한 법률」을 준수합니다<span lang=EN-US>.<br>
</span>본 개인정보 처리방침은 회사가 어떤 목적과 방식으로 개인정보를 이용하며<span lang=EN-US>, </span>이를 보호하기
위해 어떤 조치를 취하고 있는지 고객에게 설명합니다<span lang=EN-US>.<br>
</span>회사는 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 처리방침이 변경되는 경우
웹사이트<span lang=EN-US>·</span>앱 공지사항 또는 개별 통지를 통해 안내합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>1</span>조 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보의 수집
및 이용 목적</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 수집한 개인정보를 다음의
목적을 위해 활용합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNoSpacing><span lang=EN-US style='font-size:9.0pt'>1. </span><span
style='font-size:9.0pt'>서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;
</span><span style='font-size:9.0pt;color:#585852'>콘텐츠 제공<span lang=EN-US>, </span>구매
및 요금 결제<span lang=EN-US>, </span>물품배송 또는 청구지 등 발송<span lang=EN-US>, </span>본인 인증
및 구매<span lang=EN-US>, </span>요금추심</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>2. </span><span
style='font-size:9.0pt;color:#585852'>회원 관리</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;
</span><span style='font-size:9.0pt;color:#585852'>회원제 서비스 이용에 따른 본인확인<span
lang=EN-US>, </span>개인 식별<span lang=EN-US>, </span>불량회원의 부정 이용 방지와 비인가 사용 방지<span
lang=EN-US>, </span>가입 의사 확인<span lang=EN-US>, </span>가입 및 가입횟수 제한<span
lang=EN-US>, </span>추후 법정 대리인 본인확인<span lang=EN-US>, </span>분쟁 조정을 위한 기록보존<span
lang=EN-US>, </span>불만처리 등 민원처리<span lang=EN-US>, </span>고지사항 전달</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>3. </span><span
style='font-size:9.0pt;color:#585852'>마케팅 및 광고에 활용 </span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:9.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>신규 서비스<span
lang=EN-US>(</span>제품<span lang=EN-US>) </span>개발 및 특화<span lang=EN-US>, </span>이벤트
등 광고성 정보 전달<span lang=EN-US>, </span>인구통계학적 특성에 따른 서비스 제공 및 광고 게재<span
lang=EN-US>, </span>접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>2</span>조 수집하는 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보
항목 및 수집 방법</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 회원가입<span
lang=EN-US>, </span>상담<span lang=EN-US>, </span>서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다<span
lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>1.
</span></b><b><span style='font-size:9.0pt;color:#585852'>수집 항목</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>이름<span
lang=EN-US>, </span>이메일<span lang=EN-US>, </span>휴대전화번호<span lang=EN-US>, </span>신용카드
정보<span lang=EN-US>, </span>서비스 이용 기록<span lang=EN-US>, </span>접속 로그<span
lang=EN-US>, </span>결제 기록<span lang=EN-US>, </span>위치정보</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>Google,
Apple, </span><span style='font-size:9.0pt;color:#585852'>카카오톡 사용자 데이터<span
lang=EN-US> - </span>기본 프로필 정보<span lang=EN-US>(</span>이메일 주소<span lang=EN-US>)</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>2.
</span></b><b><span style='font-size:9.0pt;color:#585852'>수집 방법</span></b></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>웹사이트 및 모바일 앱<span
     lang=EN-US>(</span>회원가입<span lang=EN-US>, </span>게시판<span lang=EN-US>, </span>이벤트
     응모<span lang=EN-US>, </span>제휴 서비스<span lang=EN-US>)</span></span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>서면 양식</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>전화<span lang=EN-US>/</span>팩스</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>배송 요청</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>제휴사 제공</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>생성정보 수집 툴을 통한 자동 수집</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>차량<span lang=EN-US>/</span>휴대폰<span
     lang=EN-US> GPS </span>위치정보</span></li>
</ul>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>3</span>조 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 보유
및 이용기간</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>원칙적으로<span
lang=EN-US>, </span>개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다<span lang=EN-US>.
</span>단<span lang=EN-US>, </span>관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서
정한 일정한 기간 동안 회원정보를 보관합니다<span lang=EN-US>.</span></span></p>

<table class=MsoNormalTable border=0 cellpadding=0>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;background:whitesmoke;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>보존 항목</span></b></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;background:whitesmoke;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>보존 근거</span></b></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;background:whitesmoke;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>보존 기간</span></b></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>이름<span
  lang=EN-US>, </span>이메일<span lang=EN-US>, </span>휴대전화번호<span lang=EN-US>, </span>카드명<span
  lang=EN-US>/</span>카드번호</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>전자상거래 소비자 보호법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>5</span><span
  style='font-size:9.0pt;color:#585852'>년</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>표시<span
  lang=EN-US>/</span>광고 기록</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>전자상거래 소비자 보호법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>6</span><span
  style='font-size:9.0pt;color:#585852'>개월</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>계약<span
  lang=EN-US>/</span>청약철회 기록</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>전자상거래 소비자 보호법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>5</span><span
  style='font-size:9.0pt;color:#585852'>년</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>대금결제 및 재화 공급
  기록</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>전자상거래 소비자 보호법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>5</span><span
  style='font-size:9.0pt;color:#585852'>년</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>소비자 불만<span
  lang=EN-US>/</span>분쟁처리 기록</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>전자상거래 소비자 보호법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>3</span><span
  style='font-size:9.0pt;color:#585852'>년</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>신용정보 수집<span
  lang=EN-US>·</span>처리<span lang=EN-US>·</span>이용 기록</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>신용정보법</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>3</span><span
  style='font-size:9.0pt;color:#585852'>년</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>개인위치정보</span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>위치정보법<span
  lang=EN-US>(</span>제<span lang=EN-US>16</span>조 제<span lang=EN-US>2</span>항<span
  lang=EN-US>)</span></span></p>
  </td>
  <td style='border:solid #E6E6E6 1.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
  line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
  word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>최소<span
  lang=EN-US> 6</span>개월</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>4</span>조 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 파기
절차 및 방법</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 원칙적으로 개인<span
lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이
파기합니다<span lang=EN-US>. </span>파기절차 및 방법은 다음과 같습니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>1. </span><span
style='font-size:9.0pt;color:#585852'>파기절차<span lang=EN-US>: </span>고객이 회원가입 등을
위해 입력하신 정보는 목적이 달성된 후 별도의<span lang=EN-US> DB</span>로 옮겨져<span lang=EN-US>(</span>종이의
경우 별도의 서류함<span lang=EN-US>) </span>내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라<span
lang=EN-US>(</span>보유 및 이용기간 참조<span lang=EN-US>) </span>일정 기간 저장된 후 파기됩니다<span
lang=EN-US>. </span>별도<span lang=EN-US> DB</span>로 옮겨진 개인정보는 법률에 의한 경우에 보유 되어지는
이외의 다른 목적으로 이용되지 않습니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>2. </span><span
style='font-size:9.0pt;color:#585852'>파기방법</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>-&nbsp;&nbsp;
</span><span style='font-size:9.0pt;color:#585852'>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수
없는 기술적 방법을 사용하여 삭제합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>-&nbsp;&nbsp;
</span><span style='font-size:9.0pt;color:#585852'>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
통하여 파기합니다</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>5</span>조 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보의 위탁
처리</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 원칙적으로 고객 개인정보를
외부에 제공하지 않습니다<span lang=EN-US>. </span>다만 다음의 경우 예외로 합니다<span lang=EN-US>.</span></span></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>이용자의 사전 동의가 있는 경우</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>법령에 따른 수사기관 요청이 있는 경우</span></li>
</ul>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>1.
</span></b><b><span style='font-size:9.0pt;color:#585852'>위탁 현황</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>부록<span
lang=EN-US> 1. </span>개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 위탁
처리 현황</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>6</span>조 이용자 및 법정대리인의 권리와 행사 방법</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>이용자는 언제든지 자신의 개인정보
조회<span lang=EN-US>·</span>수정<span lang=EN-US>·</span>삭제<span lang=EN-US>·</span>탈퇴를
요청할 수 있습니다<span lang=EN-US>.</span></span></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>개인정보 변경<span
     lang=EN-US>: “</span>개인정보변경<span lang=EN-US>”, “</span>회원정보수정<span
     lang=EN-US>” </span>메뉴</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>가입 해지<span lang=EN-US>:
     “</span>회원탈퇴<span lang=EN-US>” </span>메뉴</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><span style='font-size:9.0pt'>또는 서면<span lang=EN-US>/</span>전화<span
     lang=EN-US>/</span>이메일로 개인정보관리책임자에게 요청 가능</span></li>
</ul>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>오류 정정 요청 시 정정 완료
전까지 해당 정보를 이용<span lang=EN-US>·</span>제공하지 않습니다<span lang=EN-US>.<br>
</span>잘못된 정보를 제<span lang=EN-US>3</span>자에게 이미 제공한 경우<span lang=EN-US>, </span>지체
없이 정정 결과를 제<span lang=EN-US>3</span>자에게 통보합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 이용자 혹은 법정 대리인의
요청에 의해 해지 또는 삭제된 개인정보는<span lang=EN-US> &quot;</span>㈜소네트가 수집하는 개인정보의 보유 및 이용기간<span
lang=EN-US>&quot;</span>에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다<span
lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>1. </span><span
style='font-size:9.0pt;color:#585852'>미성년자 거래시 철회</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 미성년자와의 거래시
사전에 법정대리인<span lang=EN-US>(</span>부모<span lang=EN-US>)</span>의 동의를 구할 의무가 있으며<span
lang=EN-US>, </span>법정대리인<span lang=EN-US>(</span>부모<span lang=EN-US>)</span>의 동의를
얻지 못한 거래의 경우<span lang=EN-US>, </span>거래를 취소할 수 있습니다<span lang=EN-US>. </span>또한
거래 회사자인 미성년자의 법정대리인<span lang=EN-US>(</span>부모<span lang=EN-US>)</span>이 거래 성립 후<span
lang=EN-US> 7</span>일 이내에 철회를 요청할 경우<span lang=EN-US>, </span>거래를 철회<span
lang=EN-US>(</span>환불<span lang=EN-US>)</span>하겠습니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>7</span>조 개인정보 자동수집 장치의 설치<span lang=EN-US>·</span>운영 및 거부</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>회사는 귀하의 정보를 수시로
저장하고 찾아내는<span lang=EN-US> '</span>쿠키<span lang=EN-US>(cookie)' </span>등을 운용하지 않습니다<span
lang=EN-US>. </span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>쿠키란 회사의 웹사이트를 운영하는데
이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다<span lang=EN-US>. </span>회사는
정보보안의 이유로 쿠키를 운용하지 않습니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>제<span
lang=EN-US>8</span>조 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 관련
민원서비스</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>고객은 개인정보 관련 민원을
개인정보관리자에게 신고할 수 있으며<span lang=EN-US>, </span>회사는 신속한 답변을 제공합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>1.
</span></b><b><span style='font-size:9.0pt;color:#585852'>개인<span lang=EN-US>(</span>위치<span
lang=EN-US>)</span>정보 관리 책임자</span></b></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>부서</span></b><span
     lang=EN-US style='font-size:9.0pt'>: CEO</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>성명</span></b><span
     lang=EN-US style='font-size:9.0pt'>: </span><span style='font-size:9.0pt'>김기섭</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>직위</span></b><span
     lang=EN-US style='font-size:9.0pt'>: </span><span style='font-size:9.0pt'>대표이사</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>이메일</span></b><span
     lang=EN-US style='font-size:9.0pt'>: raxi@sonnet.ai</span></li>
</ul>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>2.
</span></b><b><span style='font-size:9.0pt;color:#585852'>개인<span lang=EN-US>(</span>위치<span
lang=EN-US>)</span>정보 관리 담당자</span></b></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>부서</span></b><span
     lang=EN-US style='font-size:9.0pt'>: </span><span style='font-size:9.0pt'>사업개발팀</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>성명</span></b><span
     lang=EN-US style='font-size:9.0pt'>: </span><span style='font-size:9.0pt'>정원진</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>직위</span></b><span
     lang=EN-US style='font-size:9.0pt'>: </span><span style='font-size:9.0pt'>팀장</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>전화</span></b><span
     lang=EN-US style='font-size:9.0pt'>: 053-795-4760</span></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>이메일</span></b><span
     lang=EN-US style='font-size:9.0pt'>: raxi@sonnet.ai</span></li>
</ul>

<p class=MsoNormal align=left style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;text-align:left;text-indent:-18.0pt;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>3.
</span></b><b><span style='font-size:9.0pt;color:#585852'>외부 기관 문의처</span></b><span
lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;&nbsp; </span><span
style='font-size:9.0pt;color:#585852'>귀하께서는<span lang=EN-US>&nbsp;</span>회사의<span
lang=EN-US>&nbsp;</span>서비스를<span lang=EN-US>&nbsp;</span>이용<span lang=EN-US>&nbsp;</span>중에<span
lang=EN-US>&nbsp;</span>발생하는<span lang=EN-US>&nbsp;</span>모든<span lang=EN-US>&nbsp;</span>개인정보보호<span
lang=EN-US>&nbsp;</span>관련<span lang=EN-US>&nbsp;</span>민원을<span lang=EN-US>&nbsp;</span>개인정보관리책임자<span
lang=EN-US>&nbsp;</span>혹은<span lang=EN-US>&nbsp;</span>담당부서로<span lang=EN-US>&nbsp;</span>신고하실<span
lang=EN-US>&nbsp;</span>수<span lang=EN-US>&nbsp;</span>있습니다<span lang=EN-US>.&nbsp;</span>회사는<span
lang=EN-US>&nbsp;</span>이용자들의<span lang=EN-US>&nbsp;</span>신고사항에<span
lang=EN-US>&nbsp;</span>대해<span lang=EN-US>&nbsp;</span>신속하게<span lang=EN-US>&nbsp;</span>충분한<span
lang=EN-US>&nbsp;</span>답변을<span lang=EN-US>&nbsp;</span>드릴<span lang=EN-US>&nbsp;</span>것입니다<span
lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:18.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>기타<span
lang=EN-US>&nbsp;</span>개인정보침해에<span lang=EN-US>&nbsp;</span>대한<span
lang=EN-US>&nbsp;</span>신고나<span lang=EN-US>&nbsp;</span>상담이<span lang=EN-US>&nbsp;</span>필요하신<span
lang=EN-US>&nbsp;</span>경우에는<span lang=EN-US>&nbsp;</span>아래<span lang=EN-US>&nbsp;</span>기관에<span
lang=EN-US>&nbsp;</span>문의하시기<span lang=EN-US>&nbsp;</span>바랍니다<span
lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:18.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>. </span><span
style='font-size:9.0pt;color:#585852'>개인정보침해신고센터<span lang=EN-US>(</span></span><span
lang=EN-US style='color:black'><a
href="http://www.1336.or.kr/%EA%B5%AD%EB%B2%88%EC%97%86%EC%9D%B4"
target="_blank"><span style='font-size:9.0pt'>www.1336.or.kr/</span><span
lang=EN-US style='font-size:9.0pt'><span lang=EN-US>국번없이</span></span></a></span><span
lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;118)</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:18.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>. </span><span
style='font-size:9.0pt;color:#585852'>정보보호마크인증위원회<span lang=EN-US>(</span></span><span
lang=EN-US style='color:black'><a href="http://www.eprivacy.or.kr/02-580-0533~4"
target="_blank"><span style='font-size:9.0pt'>www.eprivacy.or.kr/02-580-0533~4</span></a></span><span
lang=EN-US style='font-size:9.0pt;color:#585852'>)</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:18.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>. </span><span
style='font-size:9.0pt;color:#585852'>대검찰청<span lang=EN-US>&nbsp;</span>인터넷범죄수사센터<span
lang=EN-US>(</span></span><span lang=EN-US style='color:black'><a
href="http://icic.sppo.go.kr/02-3480-3600" target="_blank"><span
style='font-size:9.0pt'>http://icic.sppo.go.kr/02-3480-3600</span></a></span><span
lang=EN-US style='font-size:9.0pt;color:#585852'>)</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
text-indent:18.0pt;line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>. </span><span
style='font-size:9.0pt;color:#585852'>경찰청<span lang=EN-US>&nbsp;</span>사이버테러대응센터<span
lang=EN-US>(</span></span><span lang=EN-US style='color:black'><a
href="http://www.ctrc.go.kr/02-392-0330" target="_blank"><span
style='font-size:9.0pt'>www.ctrc.go.kr/02-392-0330</span></a></span><span
lang=EN-US style='font-size:9.0pt;color:#585852'>)</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>부칙</span></b></p>

<ul style='margin-top:0cm' type=disc>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>시행일자<span
     lang=EN-US>: 2022</span>년<span lang=EN-US> 1</span>월<span lang=EN-US> 5</span>일</span></b></li>
 <li class=MsoNormal style='color:#585852;margin-bottom:0cm;text-align:left;
     line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
     word-break:keep-all'><b><span style='font-size:9.0pt'>개정일자<span
     lang=EN-US>: 2026</span>년 <span lang=EN-US>4</span>월 <span lang=EN-US>1</span>일</span></b></li>
</ul>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span lang=EN-US style='font-size:9.0pt;color:#585852'>&nbsp;</span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span style='font-size:9.0pt;color:#585852'>부록<span
lang=EN-US> 1. </span>개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보 위탁
처리 현황</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>1.
</span></b><b><span style='font-size:9.0pt;color:#585852'>현대해상화재보험㈜</span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>위탁업무 내용은 차량 사고시
처리 및 보험 보상<span lang=EN-US>, </span>비용 정산<span lang=EN-US>(</span>청구<span
lang=EN-US>), </span>보험금 지급<span lang=EN-US>/</span>심사<span lang=EN-US>, </span>보험사고
조사<span lang=EN-US>(</span>보험사기 조사 포함<span lang=EN-US>)</span>를 위하여 개인<span
lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보를 제공합니다<span lang=EN-US>.</span></span></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><b><span lang=EN-US style='font-size:9.0pt;color:#585852'>2.
PG</span></b><b><span style='font-size:9.0pt;color:#585852'>사<span lang=EN-US>(</span>나이스페이먼츠㈜<span
lang=EN-US>, </span>데이터얼라이언스㈜<span lang=EN-US>)</span></span></b></p>

<p class=MsoNormal align=left style='margin-bottom:0cm;text-align:left;
line-height:11.25pt;background:white;text-autospace:ideograph-numeric ideograph-other;
word-break:keep-all'><span style='font-size:9.0pt;color:#585852'>위탁업무 내용은 전자결제 서비스를
위하여 개인<span lang=EN-US>(</span>위치<span lang=EN-US>)</span>정보를 제공합니다<span
lang=EN-US>.</span></span></p>
`;

function TermsOfPrivacy() {
    return (
        <div>
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    );
}

export default TermsOfPrivacy;